import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

export default class GenericSidebar extends PureComponent {
  componentDidMount() {
    this.updateMql();
    this.mql.addListener(this.mediaQueryChanged);
    this.mediaQueryChanged();
  }

  componentWillUnmount() {
    this.mql.removeListener(this.mediaQueryChanged);
  }

  getStyle = () => {
    const style = { ...this.props.style };
    if (!this.props.opened) {
      style.width = 0;
      style.minWidth = 0;
    }
    return style;
  };

  updateMql = () => {
    const isPencilPage = /\/pencil\//.test(window.location.pathname);
    this.mql = window.matchMedia(
      isPencilPage ? '(min-width: 1600px)' : '(min-width: 1200px)',
    );
  };

  mediaQueryChanged = () => {
    this.updateMql();
    this.props.toggle(this.mql.matches);
  };

  render() {
    const { children } = this.props;
    return <div style={this.getStyle()}>{children}</div>;
  }
}

GenericSidebar.propTypes = {
  opened: PropTypes.bool,
  toggle: PropTypes.func,
  style: PropTypes.object,
  children: PropTypes.any,
};
